export { default } from './VitalSign';
